import script from "./SubscriptionDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionDetailPage.vue?vue&type=style&index=0&id=ff851856&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff851856"]])

export default __exports__